import { css } from 'linaria';
import { styled } from 'linaria/react';
import { media } from '../../../../../media';

export const ImgWrapperStyles = css`
	right: 0;
	display: block;
	width: auto;
	height: 500px;

	& > img {
		object-fit: cover;
		object-position: left;
	}

	${media.tablet} {
		z-index: 2;
		width: 433px;
		height: 322px;
	}

	${media.mobile} {
		width: 320px;
		height: 240px;
		margin-left: -16px;
	}
`;

export const MainInfoWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
	height: max-content;
	margin-top: 14px;
	overflow: hidden;
	column-gap: 30px;
	background-color: #f2f3f5;
	border-radius: 16px;

	@media (width >= 1024px) {
		max-height: 500px;
	}

	${media.tablet} {
		flex-direction: column;
		margin-top: 17px;
		overflow: visible;
		border-radius: 0;
	}
`;

export const TextWrapper = styled.div`
	display: grid;
	align-self: center;
	width: 502px;
	margin-inline: 48px 0;
	row-gap: 18px;
	${media.laptop} {
		row-gap: 17px;
	}
	${media.tablet} {
		margin-inline: 0;
		margin-block: 0 24px;
		width: 100%;
		row-gap: 16px;
	}
`;
